import { AppContext, IGlobalState } from '@contexts'
import { useContext } from 'react'

export const useGlobalState = () => {
    const { state } = useContext(AppContext)

    return state as IGlobalState
}
